import { BankingTab } from "@/modules/dashboard/common/enum";
import { Templates, Transactions } from "@/modules/dashboard/components/Banking";
import { getBankingTabItems } from "@/modules/dashboard/helpers";
import { AppPaths } from "@/shared/common/enums";
import { EmptyOrErrorContent, SeeMore } from "@/shared/components";
import { useAppSelector } from "@/shared/hooks";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { Tab } from "@ab.uitools/ui-library/components/Tab";
import { type ReactNode, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


type ITemplate = {
  [key in BankingTab]: ReactNode;
};

export const Banking = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { toggles } = useAppSelector((state) => state.featureToggle);
  const [selectedValue, setSelectedValue] = useState<string>(BankingTab.Transactions);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  const template: ITemplate = {
    [BankingTab.Transactions]: <Transactions/>,
    [BankingTab.Templates]: toggles.isTemplatesAvailable ? <Templates/> : (
      <div
        className="full-width flexbox align-items--center pt-32 pb-32 empty-content-wrapper">
        <EmptyOrErrorContent
          isShowButton={false}
          title={t("general.comingSoon")}
        />
      </div>
    ),
  };

  const handleSeeMore = () => {
    if (selectedValue === BankingTab.Transactions) {
      navigate(AppPaths.Transactions);
    } else {
      navigate(AppPaths.Templates);
    }
  };

  return (
    <div className="full-width banking-container" ref={sectionRef}>
      <div className="flexbox align-items--center">
        <Heading className="content-title" weight="bold" size="xsmall">
          {t("dashboard.banking.title")}
        </Heading>
        <SeeMore action={handleSeeMore} className="ml-8"/>
      </div>
      <div
        className="flexbox justify-content--between align-items--center full-width tabs-section mt-16 mb-16">
        <Tab
          size="small"
          color="light"
          tabItems={getBankingTabItems({ t })}
          selectedValue={selectedValue}
          onSelect={(value) => setSelectedValue(value as string)}
        />
      </div>
      <div className="full-width">
        {template[selectedValue as BankingTab]}
      </div>
    </div>
  );
};
